<template>
  <div id="app">
    <theme-provider
      id="application-theme-provider"
      :theme="currentTheme"
    >
      <router-view />
    </theme-provider>
  </div>
</template>

<script>
import '@estrategiahq/coruja-web-ui/dist/coruja-web-ui.css';
import '@estrategiahq/coruja-web-ui/dist/coruja-tailwind.css';
import { ThemeProvider, CThemes } from '@estrategiahq/coruja-web-ui';

export default {
  name: 'App',
  components: {
    ThemeProvider,
  },
  computed: {
    currentTheme() {
      return CThemes[sessionStorage.getItem('vertical')] || 'concursos';
    },
  },
};
</script>

<style>
.questions-inline-img img{
  display: inline;
  vertical-align: middle;
}
</style>
